import { SubscriptionTier } from '@heidi/schema/ml-scribe';

const CLINICIAN_PRODUCT_TIERS = new Set<SubscriptionTier>([
  SubscriptionTier.CLINICIAN_PRO,
  SubscriptionTier.CLINICIAN_PRO_PLUS,
  SubscriptionTier.CLINICIAN_ENTERPRISE,
]);

/** Scribe Plus / Scribe Team / Enterprise — paid Evidence tiers after a reverse trial ends. */
export function isClinicianProductTier(
  userTier: SubscriptionTier | null | undefined
): boolean {
  return userTier != null && CLINICIAN_PRODUCT_TIERS.has(userTier);
}
